/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestFormRouteImport } from './routes/test-form'
import { Route as DebugInputRouteImport } from './routes/debug-input'
import { Route as ContactoTestRouteImport } from './routes/contacto-test'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const TestFormRoute = TestFormRouteImport.update({
  id: '/test-form',
  path: '/test-form',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugInputRoute = DebugInputRouteImport.update({
  id: '/debug-input',
  path: '/debug-input',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactoTestRoute = ContactoTestRouteImport.update({
  id: '/contacto-test',
  path: '/contacto-test',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/contacto-test': typeof ContactoTestRoute
  '/debug-input': typeof DebugInputRoute
  '/test-form': typeof TestFormRoute
  '/blog/$slug': typeof BlogSlugRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/contacto-test': typeof ContactoTestRoute
  '/debug-input': typeof DebugInputRoute
  '/test-form': typeof TestFormRoute
  '/blog/$slug': typeof BlogSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/contacto-test': typeof ContactoTestRoute
  '/debug-input': typeof DebugInputRoute
  '/test-form': typeof TestFormRoute
  '/blog/$slug': typeof BlogSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contacto-test'
    | '/debug-input'
    | '/test-form'
    | '/blog/$slug'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/contacto-test' | '/debug-input' | '/test-form' | '/blog/$slug'
  id:
    | '__root__'
    | '/'
    | '/contacto-test'
    | '/debug-input'
    | '/test-form'
    | '/blog/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ContactoTestRoute: typeof ContactoTestRoute
  DebugInputRoute: typeof DebugInputRoute
  TestFormRoute: typeof TestFormRoute
  BlogSlugRoute: typeof BlogSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/test-form': {
      id: '/test-form'
      path: '/test-form'
      fullPath: '/test-form'
      preLoaderRoute: typeof TestFormRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug-input': {
      id: '/debug-input'
      path: '/debug-input'
      fullPath: '/debug-input'
      preLoaderRoute: typeof DebugInputRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacto-test': {
      id: '/contacto-test'
      path: '/contacto-test'
      fullPath: '/contacto-test'
      preLoaderRoute: typeof ContactoTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ContactoTestRoute: ContactoTestRoute,
  DebugInputRoute: DebugInputRoute,
  TestFormRoute: TestFormRoute,
  BlogSlugRoute: BlogSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
